/* Extracts the timeseries graphs for each scenario */
// Chart for just 1 scenario
import React from 'react';
import { connect } from 'react-redux';
import { range } from 'd3-array';
import { zipWith } from 'lodash';

import { idToDescription } from '../../utils';


import { scenarioColors } from '../../data/config';

import {
  getNumProjectionYears,
  PROJECTION_START_YEAR,
  PROJECTION_YEAR_DELTA,
} from '../../store/selectors';

// 3 timeseries...
import {
  getVKTSeries,
} from '../../store/selectors/vehicleDistanceTraveled';
import {
  getCarbonEmissionsTotalSeries,
} from '../../store/selectors/carbonPollution';
import {
  getPMEmissionsTotalSeries
} from '../../store/selectors/pmPollution';

//
const BaseSingleScenario = (props) => {
  const scenarioKey = props.scenarioKey;
  return props.children({
    [scenarioKey]: props[scenarioKey],
    numYears: props.numYears
  })
}

const makeMapStateToProps = (initialState, initialProps) => {
  // console.log("initialProps", initialProps);
  const mapStateToProps = (state, props) => {
    const { dataName } = props;
    let dataSelector;
    switch (dataName) {
      case "co2Emissions":
        dataSelector = getCarbonEmissionsTotalSeries;
        break;
      case "pm25Emissions":
        dataSelector = getPMEmissionsTotalSeries;
        break;
      case "vehicleKilometersTraveled":
        dataSelector = getVKTSeries;
        break;
      default:
        dataSelector = getVKTSeries;
    }
    return {
      [props.scenarioKey]: dataSelector(state, props),
      numYears: getNumProjectionYears(state)
    }
  }
  return mapStateToProps;
}


const makeChartDataFromScenarios = (scenarios, numYears) => {
  const YEAR_SERIES = range(PROJECTION_START_YEAR, PROJECTION_START_YEAR + numYears + 1);
  const keys = [
    'bau', 'secondary', 'primary',
  ].reverse();

  const marks = [];
  keys.forEach((scenarioKey, i) => {
    const scenarioSeries = scenarios[scenarioKey];
    const combined = zipWith(scenarioSeries, YEAR_SERIES, (scenarioValue, year) => {
      return {
        'x': year,
        'y': scenarioValue,
      }
    });
    // The first 3 years of the projection, we actually don't need.
    const final = combined.slice(PROJECTION_YEAR_DELTA);
    marks.push({
      color: scenarioColors[scenarioKey],
      data: final,
      id: idToDescription(scenarioKey),
    });
  });

  return marks;
}

const SingleScenario = connect(
  makeMapStateToProps,
  null, // mapDispatchToProps
)(BaseSingleScenario);

// TODO... is there some way to compose these
// components without doing this weird nesting?
// react-adopt, composer, etc
export const AllScenarioWrapper = (props) => {
  const { dataName } = props;
  return (
    <SingleScenario scenarioKey="bau" dataName={dataName}>
      {({ bau }) => (
        <SingleScenario scenarioKey="primary" dataName={dataName}>
          {({ primary }) => (
            <SingleScenario scenarioKey="secondary" dataName={dataName}>
              {({ secondary, numYears }) => {
                const scenarioMap = {
                  bau,
                  primary,
                  secondary
                }
                const chartData = makeChartDataFromScenarios(scenarioMap, numYears);
                return props.children({
                  chartData,
                })
              }
              }
            </SingleScenario>
          )}
        </SingleScenario>
      )}
    </SingleScenario>
  );
};



// WEBPACK FOOTER //
// ./src/components/resultsPane/allScenarioWrapper.js